import React, {ElementRef} from 'react';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogos , cargarCatalogosGenerico, cargarCatalogosGenericoAsync, cargarCatalogosAsync, cargarCatalogos_Otros/*, cargarCatalogosGenericoAsyncInvertido */} from '../../funciones_globales/catalogos';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, ContainerEdit,TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera, LabelTotales, LabelValorTotales } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PuntoFacturacion from '../ventas/puntoFacturacion';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearNumeroDecimal, completar_String } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import SelectArticulo from '../inventario/selectArticulo';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { formatearFecha,formatearNumeroEntero} from '../../funciones_globales/format';

const ContenedorModalOrden = styled.div`
    margin-top: 20px;
    height: 100%;
    width: 610px;
`

const InputText2 = styled.input`
    height: 27px;
    padding: 5px 10px;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 3px;    
    width: 50%;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
`;

const ContenedorBoton = styled.div`
  padding-top: 17px;  
  @media (max-width: 991px) {
    padding-top: 0px;
  }
`;

const ContenedorModal = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 100%;
`;

const ContenedorBotonAdd = styled.div`
    padding-top: 20px;
    @media (max-width: 991px){
        padding: 0px;
    }
`;

class FormComp11 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Parametros Globales
            movCompra: '',
            operacion: 'G',
            permiso: null,
            ult_transaccion: null,//Ultima transaccion operada
            num_diario: null, //Ult. diario
            diasPago: 1,
            cuentaIVAPagado: null,
            planVigente: null, 
            paramDiasRetencion: null, 
            paramIva: null, 
            errorCuentas: 0, //0 Normal, 1 Error         
            
            //control de fechas
            fechaProceso: null,
            fechaFactura: null,
            fechaVencimiento: null,

            //Proveedor
            proveedor_sel: null,
            proveedor: null,
            ctaContable: null,
            debitoBancario: 'N',

            //Orden Pago
            //opt_orden_pago: [],
            //orden_compra_sel: null,

            //Bodega control
            bodega_sel: '01',
            opt_bodegas: [],
            modStock: 'S',

            //Factura Control
            num_doc: '',
            num_doc_serie: '',
            totalDocumento: 0,

            //Articulo Control
            articulo_sel: null,
            ivaArticulo: 'N',
            cantArt: '',
            precioUnit: '',
            descuentoArt: '',
            descuentoPorcArt: '0',

            //Indicadores Valores
            subtotalSinIva: 0,
            descuentoTotal: 0,
            totalBruto: 0,
            baseIva: 0,
            baseIva0: 0,
            totalIva: 0,
            totalNeto: 0,

            //FocusRef
            asyncRef: ElementRef, //ReactSelectAsync

            //Options
            tipo_compra_opt: [],
            tipo_compra_sel: null,

            tipoDocumento: [],
            tipoDocumento_sel: null,
            tipoDocDefault: null,

            //Modales
            isOpenRetencion: false,
            opt_impuestos: [],
            opt_impuestos_sel: null,
            porcentaje_imp: '',
            base_imponible: '',
            valor_impuesto: '',
            rubroVisible: false, //Control para ocultar la fila rubro
            total_retencion: 0,

            //Input
            concepto: '',

            //revisar Retencion
            retencionRevisada: false,

            //Modal OrdenCompra
            isOpenOrdenCompra: false,

            //GRIDS COLUMNS
            gridOrdenesCompra: [], 
            columnDefsOrdenCompra:[
                                    {   header: "",
                                        width: 30,
                                        suppressRowClickSelection: true,
                                        checkboxSelection: true,
                                        suppressSorting: true,
                                        suppressMenu: true,
                                        suppressFilter: true,
                                        pinned: true                                                
                                    }, 
                                    {   header: "Orden",
                                        field: "OrdenCompra",
                                        width: 50,
                                        type: "string"                                                 
                                    },
                                    {   header: "Fecha",
                                        field: "Fecha",
                                        width: 70,
                                        type: "fecha"                                                 
                                    },
                                    {   header: "Observacion",
                                        field: "Observacion",
                                        width: 270,
                                        type: "string"                                                                                   
                                    },
                                    {   header: "FormaPago",
                                        field: "FormaPago",
                                        width: 80,
                                        type: "string"                                                                           
                                    },
                                    {   header: "Importe",
                                        field: "Importe",
                                        width: 80,
                                        type: "num_decimal"                                           
                                    }
                                ],

            gridRetenciones: [],
            columnDefsRetenciones: [  
                                        {   header: "",
                                            field: "eliminar",
                                            width: 50,
                                            type: "link_elim"                                           
                                        },
                                        {   header: "Tipo",
                                            field: "tipo_descripcion",
                                            width: 50,
                                            type: "string"                                                 
                                        },
                                        {   header: "Cod.",
                                            field: "codigo",
                                            width: 34,
                                            type: "string"                                                 
                                        },
                                        {   header: "Descripción",
                                            field: "descripcion",
                                            width: 120,
                                            type: "string"                                                                                   
                                        },
                                        {   header: "%",
                                            field: "porcentaje",
                                            width: 25,
                                            type: "num_entero"                                                                           
                                        },
                                        {   header: "Base calculo",
                                            field: "base_calculo",
                                            width: 80,
                                            type: "num_decimal"                                           
                                        },
                                        {   header: "Valor",
                                            field: "valor",
                                            width: 50,
                                            type: "num_decimal"                                                                                  
                                        },
                                        {   header: "Rubro",
                                            field: "rubro_num",
                                            width: 50,
                                            type: "string"                                           
                                        },
                                        {   header: "Descripcion rubro",
                                            field: "rubro",
                                            width: 295,
                                            type: "string"                                           
                                        }
                                    ],
            gridDetalleArt: [],
            columnDefsDetalleArt: [
                                    {   header: 'Artículo',
                                        children: [
                                                    {   header: "N°",
                                                        field: "numero",
                                                        width: 30,
                                                        type: "string"                                                 
                                                    },
                                                    {   header: "Cod. Art.",
                                                        field: "codigoArticulo",
                                                        width: 70,
                                                        type: "string"                                                 
                                                    },
                                                    {   header: "Descripción",
                                                        field: "descripcion",
                                                        width: 350,
                                                        type: "string"                                                 
                                                    },
                                                    {   
                                                        header: "Ind. IVA",
                                                        field: "indicadorIva",
                                                        width: 60,
                                                        type: "string"                                             
                                                    },
                                        ]                                              
                                    },
                                    {   header: 'Precio',
                                        children:[
                                                    {   
                                                        header: "Cantidad",
                                                        field: "cantidad",
                                                        width: 70,
                                                        type: "num_entero"                                             
                                                    },                                    
                                                    {   header: "P. Unit.",
                                                        field: "precioUnitario",
                                                        width: 90,
                                                        type: "num_decimal_edit", //4 Decimales 
                                                        editable: false,
                                                        valueFormatter: this.formatearNumero                                           
                                                    },
                                                    {   header: "SubTotal",
                                                        field: "subTotal",
                                                        width: 90,
                                                        type: "num_decimal"
                                                    }
                                        ]
                                    },
                                    {   header: 'Descuento',
                                        children: [
                                                    {   header: "% Dscto.",
                                                        field: "porcDescuento",
                                                        width: 70,
                                                        type: "num_decimal" //4 Decimales                                            
                                                    },
                                                    {   header: "Val. Dscto.",
                                                        field: "valorDescuento",
                                                        width: 90,
                                                        type: "num_decimal"
                                                    }
                                        ]
                                    },
                                    {
                                        header: 'Total',
                                        children: [
                                            {   header: "Total Linea",
                                                field: "totalLinea",
                                                width: 85,
                                                type: "num_decimal"
                                            }
                                        ]
                                    },                                    
                                    // {   header: "",
                                    //     field: "eliminar",
                                    //     width: 50,
                                    //     type: "link_elim"                                           
                                    // }                                 
                                ],
        };

        //GRID OPTIONS
        this.gridOptionsDetalleArt = {
            context: {
                componentParent: this
            },
            rowSelection: 'single',
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDoubleClicked:(event)=>{
                if(this.state.articulo_sel || this.state.cantArt || this.state.precioUnit ){
                    alert(' - Se encuentra añadiendo un artículo, añadalo o limpie para continuar')
                }else{
                    let fila = event.data
                    //SET TO ADDITEMS CONTROLS
                    if(fila.controlDescuento === 'descuentoArt'){
                        this.setState({descuentoArt: fila.valorDescuento.toString(), descuentoPorcArt: ''})
                    }else if(fila.controlDescuento === 'descuentoPorcArt'){
                        this.setState({descuentoArt: '', descuentoPorcArt: fila.porcDescuento.toString()})
                    }

                    this.setState({articulo_sel: {value: fila.codigoArticulo, label: fila.descripcion}, 
                        ivaArticulo: fila.indicadorIva, cantArt: fila.cantidad, precioUnit: fila.precioUnitario, retencionRevisada: false }, ()=>{
                            this.setState({gridDetalleArt: this.immutableDelete(this.state.gridDetalleArt, event.rowIndex)})
                    })
                }
                
            }
        }

        this.gridOptionsRetenciones = {
            context: {
                componentParent: this
            },
            rowSelection: 'single',
            enableColResize: true,
            enableCellChangeFlash: true
        }

        this.gridOptionsOrdenesCompra = {
            context: {
                componentParent: this
            },
            rowSelection: "multiple",
            enableColResize: true,
            enableCellChangeFlash: true
        }

        //Handdlers
        this.changeNumSerie =this.changeNumSerie.bind(this);
        this.changeNumFactura = this.changeNumFactura.bind(this);
        this.validNumSerie = this.validNumSerie.bind(this);
        this.validadFacturaProveedor = this.validadFacturaProveedor.bind(this);
        this.setProveedor = this.setProveedor.bind(this);
        this.fixtoNumberIn = this.fixtoNumberIn.bind(this);
        this.evalNumberInput = this.evalNumberInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleAddArticulo = this.handleAddArticulo.bind(this);
        this.handleDeleteArticulo = this.handleDeleteArticulo.bind(this);
        this.changeDiasPago = this.changeDiasPago.bind(this);
        this.corregirValor = this.corregirValor.bind(this);
        this.formatearNumero = this.formatearNumero.bind(this);

        //Modals
        this.retencionesAutomaticas = this.retencionesAutomaticas.bind(this);
        this.toggleModalRetencion = this.toggleModalRetencion.bind(this);
        this.closeRetencion = this.closeRetencion.bind(this);
        this.updateBaseImp = this.updateBaseImp.bind(this);
        this.toogleOrdenesCompra = this.toogleOrdenesCompra.bind(this);
        this.closeOrdenCompra = this.closeOrdenCompra.bind(this);

        //Action Buttons
        this.guardarCompraLocal = this.guardarCompraLocal.bind(this);
        this.getCompra = this.getCompra.bind(this);
        this.impCompra = this.impCompra.bind(this);

        //GRIDS
        this.onGridReadyDetalleArt = this.onGridReadyDetalleArt.bind(this);
        this.onGridReadyRET = this.onGridReadyRET.bind(this);
        this.onGridOrdenCompra = this.onGridOrdenCompra.bind(this);
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                console.log("ERROR ",err)
                reject('Compra no existe o esta anulada...');
            });
        });
    }

    //Formater
    formatearNumero(params){
        return parseFloat(params.value).toFixed(4).toString().replace(/(\d)(?=(\d{6})+(?!\d))/g, "$1,");
    }

    getCompra(){
        if(this.state.movCompra === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.movCompra,10) <= 0 ){
            alert("Movimiento no válido");
            this.clear('B');
        }else{
            
            this.props.cambiar_VisualizacionLoading(true);
            Promise.all([
                this.cargarObjetos('compras/'+this.state.movCompra.toString()),
                this.cargarObjetos('retenciones?compra='+this.state.movCompra.toString())
            ])
            .then(([result_compra, result_retencion])=>{
                this.props.cambiar_VisualizacionLoading(false); 
                if(result_compra){
                    let res = result_compra;
                    let arrayArticulos = res.detalle_compra;
                    this.seteoCabecera(result_compra)

                    let conMovimiento = null;
                    if(res.ConMovimiento){
                        conMovimiento = res.ConMovimiento
                    }

                    cargarCatalogosGenerico('/proveedores?tipo=catalogo&cadena_busq='+res.Proveedor).then((result)=>{
                        this.setState({proveedor_sel: result[0]}, ()=>{
                            //Asignacion Objeto Proveedor
                            this.setProveedor(this.state.proveedor_sel)

                            //Carga DebitoBancario
                            if(res.DebitoBancario!==null){
                                this.setState({debitoBancario: res.DebitoBancario})
                            }else{
                                this.setState({debitoBancario: 'N'})
                            }
                        });
                    })

                    //ASIGNACION DE VALORES RET IVA Y RET FTE
                    let impRetIva=0,impRetRtf=0;
                    result_retencion.forEach((RET)=>{
                        if(RET.Observacion === 'IVA'){
                            impRetIva += Math.round((RET.BaseCalculo * (RET.Porcentaje/100))*100)/100;
                        }else{
                            impRetRtf += Math.round((RET.BaseCalculo * (RET.Porcentaje/100))*100)/100;
                        }
                    })
                    
                    this.setState({impRetIva: impRetIva,impRetRtf: impRetRtf, 
                        total_retencion: Math.round((impRetIva + impRetRtf)*100)/100, num_diario: conMovimiento},()=>{
                        //Cargar DCompra
                        this.cargarDCompra(arrayArticulos);

                        //Cargar Retenciones
                        this.cargarRetenciones(result_retencion);
                    })
                }
            })
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);        
                alert(error);      
            });
        }
    }

    seteoCabecera(res){
        //Seteo Proveedor
        //FechaDocumento
        var fecha = new Date(res.Fecha).toISOString().substring(0,10)
        fecha = moment(formatearFecha(fecha), 'DD/MM/YYYY')

        //FechaVencimiento
        var fechaVencimiento = new Date(res.FechaVencimiento).toISOString().substring(0,10)
        fechaVencimiento = moment(formatearFecha(fechaVencimiento), 'DD/MM/YYYY')

        //FechaTransaccion
        var fechaProceso;
        if(res.FechaTransaccion){
            fechaProceso = new Date(res.FechaTransaccion).toISOString().substring(0,10)
            fechaProceso = moment(formatearFecha(fechaProceso), 'DD/MM/YYYY')
        }

        let creditoSelect = null
        if(res.CreditoTributario){
            creditoSelect = res.CreditoTributario
        }

        let debitoSelect = null
        if(res.DebitoBancario){
            debitoSelect = res.DebitoBancario
        }

        //CARGA DEL TIPO DOCUMENTO
        let tipoDoc = null;
        if(res.Tipo){
            this.state.tipoDocumento.forEach((DATA)=>{
                if(DATA.value === res.Tipo){
                    tipoDoc = DATA;
                }
            })
        }

        let observacion = '';
        if(res.Observacion){
            observacion = res.Observacion;
        }

        //Serie Documento
        var serie = "";
        serie = res.Establecimiento+''+res.PuntoVenta

        //modStock Afectacion bodega
        let modStock = 'N';
        if(res.AfectacionBodega === true){
            modStock = "S"
        }else if(res.AfectacionBodega === false){
            modStock = "N"
        }
        
        //Totales
        let totalDocumento = 0;
        if(res.Importe){
            totalDocumento = Math.round(parseFloat(res.Importe)*100)/100;
        }

        this.setState({
            fechaFactura: fecha, fechaVencimiento: fechaVencimiento, fechaProceso: fechaProceso,    
            debitoBancario: debitoSelect, diasPago: res.DiasPg, tipo_compra_sel: creditoSelect, tipoDocumento_sel: tipoDoc, 
            num_doc_serie: serie, num_doc: res.Factura, estadoCompra: res.Status, concepto: observacion,
            modStock: modStock, totalDocumento: totalDocumento,
        })
    }

    cargarRetenciones(ret){
        //Cargar Retenciones
        let retenciones = [], grid_retencion = [], accRET = 0;
        retenciones = ret;
        retenciones.forEach((DATA)=>{
            var item = {};
            let imp = {}
            if(DATA.Codigo !== null){
                imp = this.obtenerDataCatalogo(this.state.opt_impuestos , DATA.Codigo.toString().trim(), "value");
                console.log('RESULTADO CONSULTA RET: ',imp)
                //DESARROLLO
                item.CuentaRetencion1 = DATA.CuentaRetencion1;
                item.base_calculo = DATA.BaseCalculo;
                item.codigo =  (DATA.Codigo).trim();
                item.descripcion = imp.label;
                item.porcentaje = DATA.Porcentaje
                item.Tipo = DATA.tipoTransaccion
                item.tipo_descripcion = DATA.tipoTransaccion==='S'?'Servicios':'Bienes';
                item.rubro_num = (DATA.Drubro!==null?DATA.Drubro.Codigo:"");
                item.rubro = (DATA.Drubro!==null?DATA.Drubro.Descripcion.toUpperCase():"");
                item.TipoImp = (DATA.Observacion==="IVA"?"IVA":"RTF")
                item.valor = Math.round((DATA.BaseCalculo * (DATA.Porcentaje/100)) * 100) / 100
                
                accRET = accRET + item.valor

                //UPDATE VAL NETO
                //Actualizacion de valor neto a pagar
                //this.actualizarValorNeto(this.state.val_neto_doc, item.valor, "-");
                grid_retencion.push(item);
            } 
        })

        this.setState({gridRetenciones: grid_retencion})
        
    }

    cargarDCompra(array){
        if(array.length > 0){
            let detalleArt = [];
            let bodega = null;
            array.forEach((DATA, i)=>{
                let fila = {};

                fila.numero = i + 1;
                fila.codigoArticulo = DATA.Articulo;
                fila.descripcion = DATA.art?DATA.art.Nombre:'';
                fila.indicadorIva = DATA.Iva===true?'S':'N';
                fila.cantidad = DATA.Cantidad;
                fila.precioUnitario = DATA.Precio?parseFloat(DATA.Precio,10).toFixed(4):0;
                fila.subTotal = Math.round(parseFloat(fila.cantidad * fila.precioUnitario).toFixed(4)*100)/100; 

                bodega = DATA.Bodega;

                /* CUANDO EXISTE VALOR DESCUENTO */
                console.log('entro a EXISTE VALOR DESCUENTO: ', fila.valorDescuento, 'SUBTOTAL: ', fila.subTotal)
                fila.valorDescuento = DATA.Descuento?parseFloat(DATA.Descuento,10):0;
                fila.porcDescuento = parseFloat(fila.valorDescuento*100)/fila.subTotal;
                fila.controlDescuento = 'descuentoArt';
                fila.totalLinea = (fila.subTotal-fila.valorDescuento)
                detalleArt.push(fila);
            })
            
            this.setState({gridDetalleArt: detalleArt, bodega_sel: bodega}, ()=>{
                this.clearAddItems();
                this.sumaGridDetalleArticulo();
            })
        }
    }

    corregirValor(){
        if(this.state.totalDocumento===''){
            this.setState({totalDocumento: 0})
        }
    }

    //GRID
    onGridReadyDetalleArt(params){
        this.apiGridDetalleArt = params.api;
        this.columnApiDetalleArt = params.columnApi;
    }

    onGridReadyRET(params){
        this.apiRet = params.api;
        this.columnApiRet = params.columnApi;
    }

    onGridOrdenCompra(params){
        this.apiOrden = params.api;
        this.columnApiOrden = params.columnApi;
    }

    cargarCatalogos_OtrosParametrosSimplex(tipo) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                console.log("COLLECCION DESDE SP: ",response.data)
                
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    //REACT Cycle
    componentDidMount(){
        Promise.all([ 
            this.cargarObjetos('/secuenciales/Compra'),
            this.cargarCatalogos_OtrosParametrosSimplex('COM-TIPCOMP'), 
            cargarCatalogos_Otros('COM-NOBJIVA'),
            cargarCatalogos_Otros('GEN-PLANVIG'),
            this.cargarCatalogos_Otros_Save('COM-IMPALL'),
            cargarCatalogos_Otros('COM-DIASRET'),
            cargarCatalogos('Bodega'),
            cargarCatalogos_Otros('COM-IVAPG'),
            cargarCatalogos_Otros('COM-CTTRIBUTAR'),
            this.props.generar_LogAuditoriaIngresoForm('0611')
        ]).then(([ secCompra, result_tipoDocumento, result_paramNOBJIVA, planVigente, catalogoImp, paramDiasRetencion, opt_bodegas, porcentajeIVA, result_TipoCompra])=>{
            let array = []
            catalogoImp.forEach((DATA)=>{
                let item = {};

                item.value = DATA.Codigo
                item.label = `${DATA.Descripcion} (${DATA.Codigo})`
                item.tipo = DATA.Tipo
                item.porcentaje = DATA.Porcentaje
                item.CContableCliPJ = DATA.CContableCliPJ;
                item.CContableCliPN = DATA.CContableCliPN;
                item.CContableProvPJ = DATA.CContableProvPJ;
                item.CContableProvPN = DATA.CContableProvPN;
                
                array.push(item);
            })
            catalogoImp = array;

            //FORMATEO TIPO COMPRA
            let arrayTipoCompra = [];
            let tipoDocDefault = null;
            result_tipoDocumento.forEach((TIPO)=>{
                let items = {}
                items.value = TIPO.Codigo;
                items.label = TIPO.Descripcion+` (${TIPO.Codigo})`;
                items.NoProcesarRet = TIPO.Observacion;
                items.ImportParam = TIPO.Nombre;

                if(TIPO.Codigo === 'F'){
                    tipoDocDefault = items;
                }
                arrayTipoCompra.push(items)
            })

            let fechaProceso = getFechaProcesoPorModulo('06');
            
            this.setState({ ult_transaccion: completar_String(secCompra.codigo -1, '0', 6), tipoDocumento: arrayTipoCompra, parametroNo_OBJ_IVA: result_paramNOBJIVA[0].value ,
            planVigente: planVigente[0].value, 
            opt_impuestos: catalogoImp, fechaProceso: moment(fechaProceso, 'DD/MM/YYYY'), paramDiasRetencion: parseInt(paramDiasRetencion[0].value, 10),
            opt_bodegas: opt_bodegas, paramIva: parseInt(porcentajeIVA[0].value, 10), tipo_compra_opt: result_TipoCompra,
            fechaFactura: moment(fechaProceso,'DD/MM/YYYY'), fechaVencimiento: moment(fechaProceso,'DD/MM/YYYY').add(this.state.diasPago, 'days'),
            permiso: this.props.permiso, tipoDocDefault: tipoDocDefault, tipoDocumento_sel: tipoDocDefault });

        }).catch((error)=>{
            alert('Error al cargar datos iniciales', error);
        })
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0611');
    }

    //Focus para select async
    focusAsync(){
        this.asyncRef.focus();
    }

    //Modals
    toggleModalRetencion(){
        this.setState({isOpenRetencion: !this.state.isOpenRetencion, retencionRevisada: true},()=>{
            this.retencionesAutomaticas()
        })
    }

    closeRetencion(){
        this.setState({isOpenRetencion: false}, ()=>{
            this.sumaGridDetalleArticulo();
            this.clearAddImp();
        })
    }

    updateBaseImp(event){
        const target = event.target;       
        let value = target.value; 

        if(value > 0){
            var totalImp = 0;
            totalImp = value * (parseInt(this.state.porcentaje_imp,10)/100);
            this.setState({valor_impuesto: Math.round(totalImp * 100) / 100});
        }
    }

    //Procedures
    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if(target.type === 'checkbox' && value === true){
            value = 'S';
        }else if(target.type === 'checkbox' && value === false){
            value = 'N';
        }

        this.setState({
          [name]: value
        });
    }

    evalNumberInput(event){
        const target = event.target;
        let value = target.value;
        const name = target.name;
        if(value){
            if(isNaN(value)===false){
                this.setState({[name]: value})

                if(name === 'descuentoPorcArt'){
                    this.setState({descuentoArt: ''})
                }else if(name === 'descuentoArt'){
                    this.setState({descuentoPorcArt: ''})
                }

            }
        }else{
            this.setState({[name]: ''})
        }        
    }

    fixtoNumberIn(event){
        const target = event.target;
        let value = target.value;
        const name = target.name;

        if(value){
            let valor = parseInt(value, 10);
            if(Number.isNaN(valor)===false){
                this.setState({[name]: valor})
            }else{
                this.setState({[name]: ''})
            }
        }else{
            this.setState({[name]: ''})
        }
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    changeFechaProceso(value){
        //let paramdiasPago = this.state.diasPago?this.state.diasPago:1;
        if(value){
            let fechaProceso = formatearFechaMoment_a_String(value);
            if(validarFechaMomentEnFormatoString(fechaProceso)){ 
                /* FECHA CORRECTA */               
                this.setState({fechaProceso: value}, ()=>{
                    this.changeFecha(value);
                })                
            }else{
                /* FECHA INVALIDA */
                let envio = getFechaProcesoPorModulo('06');
                this.setState({fechaProceso: moment(envio, 'DD/MM/YYYY')}) 
            }            
        }else{
            /* FECHA NULL */
            this.setState({fechaProceso: null}) 
        }
    }

    changeFecha(value){
        let paramdiasPago = this.state.diasPago?this.state.diasPago:1;
        if(value){
            
            let fechaDocumento = formatearFechaMoment_a_String(value);
            if (!validarFechaMomentEnFormatoString(fechaDocumento)){
                /* Fecha Incorrecta */   
                console.log('FECHA INCORRECTA')       
                fechaDocumento = getFechaProcesoPorModulo('06');
                this.setState({fechaFactura: null, 
                fechaVencimiento: moment(fechaDocumento,'DD/MM/YYYY').add(paramdiasPago, 'days'), diasPago: paramdiasPago},()=>{
                    this.setState({fechaFactura: moment(fechaDocumento, 'DD/MM/YYYY')})
                })
            }else{
                /* Fecha Correcta */ 
                console.log('FECHA CORRECTA')
                let fechaProceso = this.state.fechaProceso?formatearFechaMoment_a_String(this.state.fechaProceso):getFechaProcesoPorModulo('06');
                let fechaMaxRetroDocumento = moment(fechaProceso, 'DD/MM/YYYY').subtract(this.state.paramDiasRetencion, 'days')
                let fechaMaxRetroReal = moment(fechaProceso, 'DD/MM/YYYY').subtract(this.state.paramDiasRetencion, 'days').subtract(1,'days')
                fechaProceso = moment(fechaProceso, 'DD/MM/YYYY');

                let FechaValid = value.isBetween(fechaMaxRetroReal, fechaProceso)

                if(FechaValid===true){
                    /* Dentro del Rango */ 
                    console.log('FECHA DENTRO DEL RANGO')
                    this.setState({fechaFactura: null, 
                    fechaVencimiento: moment(fechaDocumento,'DD/MM/YYYY').add(paramdiasPago, 'days'), diasPago: paramdiasPago},()=>{
                        this.setState({fechaFactura: value})
                    })
                }else{
                    /* Fuera del Rango */
                    console.log('FECHA FUERA DEL RANGO')
                    fechaDocumento = this.state.fechaProceso?formatearFechaMoment_a_String(this.state.fechaProceso):getFechaProcesoPorModulo('06');
                    this.setState({fechaFactura: null, 
                    fechaVencimiento: moment(fechaDocumento,'DD/MM/YYYY').add(paramdiasPago, 'days'), diasPago: paramdiasPago},()=>{
                        this.setState({fechaFactura: moment(fechaDocumento, 'DD/MM/YYYY')})
                    })
                    alert(`Se puede retroceder la fecha de documento hasta: ${formatearFechaMoment_a_String(fechaMaxRetroDocumento)}`)
                }
            }
        }else{
            /* Fecha Invalida */
            let fechaDocumento = this.state.fechaProceso?formatearFechaMoment_a_String(this.state.fechaProceso):getFechaProcesoPorModulo('06');;
            this.setState({fechaFactura: moment(fechaDocumento, 'DD/MM/YYYY'), 
            fechaVencimiento: moment(fechaDocumento,'DD/MM/YYYY').add(paramdiasPago, 'days'), diasPago: paramdiasPago})            
        }        
    }

    changeDiasPago(){
        if(this.state.diasPago){
            if(this.state.fechaFactura && this.state.fechaProceso){
                let dias = parseInt(this.state.diasPago,10);
                let fechaFactura = formatearFechaMoment_a_String(this.state.fechaFactura);
                let fechaVencimiento = null;

                fechaVencimiento = moment(fechaFactura,'DD/MM/YYYY').add(dias, 'days')
                this.setState({diasPago: dias, fechaVencimiento: fechaVencimiento})
            }            
        }else{
            this.setState({diasPago:1})
        }
    }

    getOptions_RubroImp(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = input;
            cargarCatalogosAsync('Retencion', cadena_busq, callback)
        }
    }

    cargarCatalogos_Otros_Save(tipo){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion='+tipo)
            .then((response)=>{                
                resolve(response.data)
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    handleAddArticulo(){
        let proceder = true;
        let errors = '';

        if(!this.state.articulo_sel){
            proceder = false;
            errors+=`- Seleccione un articulo\n`
        }

        if(!this.state.cantArt){
            proceder = false;
            errors+=`- Ingrese una cantidad\n`
        }

        if(!this.state.precioUnit){
            proceder = false;
            errors+=`- Ingrese un precio al artículo\n`
        }

        if(!this.state.descuentoArt && !this.state.descuentoPorcArt){
            proceder = false;
            errors+=`- Ingrese un valor o porcentaje de descuento\n`
        }

        if(proceder === true){
            let fila = {};

            fila.numero = this.state.gridDetalleArt.length===0?1:this.state.gridDetalleArt.length-1;
            fila.codigoArticulo = this.state.articulo_sel.value;
            fila.descripcion = this.state.articulo_sel.label;
            fila.indicadorIva = this.state.ivaArticulo;
            fila.cantidad = this.state.cantArt;
            fila.precioUnitario = parseFloat(this.state.precioUnit,10).toFixed(4);
            fila.subTotal = Math.round(parseFloat(fila.cantidad * fila.precioUnitario)*100)/100; 

            if(this.state.descuentoArt && !this.state.descuentoPorcArt){
                /* CUANDO EXISTE VALOR DESCUENTO */
                console.log('entro a EXISTE VALOR DESCUENTO: ', fila.valorDescuento, 'SUBTOTAL: ', fila.subTotal)
                fila.valorDescuento = parseFloat(this.state.descuentoArt,10)*100
                fila.porcDescuento = parseFloat(fila.valorDescuento*100)/fila.subTotal*100;
                fila.controlDescuento = 'descuentoArt';
            }else if(!this.state.descuentoArt && this.state.descuentoPorcArt){
                /* CUANDO EXISTE % DESCUENTO */
                console.log('CUANDO EXISTE % DESCUENTO', this.state.descuentoArt)

                fila.porcDescuento = parseInt(this.state.descuentoPorcArt,10)
                let op = fila.subTotal * (parseInt(this.state.descuentoPorcArt,10)/100)
                
                fila.valorDescuento = parseFloat(op)//Math.round(op*100)/100;
                fila.controlDescuento = 'descuentoPorcArt';
                console.log('%Desc: ', this.state.descuentoPorcArt, 'SUBTOTAL: ', fila.subTotal, 'VALOR DESCUENTO: ', op, 'V D PARSED: ', fila.valorDescuento)
            }
            
            fila.totalLinea = fila.subTotal-fila.valorDescuento
            this.setState({gridDetalleArt: this.immutablePush(this.state.gridDetalleArt, fila), retencionRevisada: false}, ()=>{
                this.clearAddItems();
                this.focusAsync();
                this.sumaGridDetalleArticulo();
            })
        }else{
            alert(errors);
        }
    }

    handleDeleteArticulo(){
        let msg = window.confirm(' ¿Eliminar la linea actual?')
        
        if(msg){
            let filasSeleccionadas = this.apiGridDetalleArt.getSelectedRows();
            let itemArticulo= filasSeleccionadas[0];
            if (this.state.gridDetalleArt.length===0){
                alert('No existen artículos en la proforma.');
                return;
              }
        
            if (filasSeleccionadas[0]===undefined){
            alert('Debe seleccionar el artículo que desee eliminar.')
            return;
            }
            let indiceEliminar;
            for(indiceEliminar=0; indiceEliminar<this.state.gridDetalleArt.length; indiceEliminar++){
                if (this.state.gridDetalleArt[indiceEliminar].numero === itemArticulo.numero){
                break;
                }
            }
            this.setState({ gridDetalleArt: this.deleteItemArray(this.state.gridDetalleArt, indiceEliminar) }, ()=>{
                this.clearAddItems();
                this.sumaGridDetalleArticulo();
              });
          
        }
    }
    deleteItemArray (arr, index) {
        let indice = formatearNumeroEntero(index);
        let arr_tmp = arr.slice(0, indice).concat(arr.slice(indice+1));
        arr_tmp.forEach((item, i)=>{
          item.NroItem = completar_String((i + 1).toString(), '0', 3);
        });
        return arr_tmp;
    }

    sumaGridDetalleArticulo(){
        let subtotalSinIva = 0, descuentoTotal = 0, totalBruto = 0, baseIva = 0,
        baseIva0 = 0, totalIva = 0, totalNeto = 0

        this.state.gridDetalleArt.forEach((DATA, i)=>{
            DATA.numero = i+1;
            subtotalSinIva+= parseFloat(DATA.subTotal,10)
            descuentoTotal+= parseFloat(DATA.valorDescuento,10);
            totalBruto+=DATA.totalLinea; 

            if(DATA.indicadorIva === 'S'){
                baseIva+=parseFloat(DATA.totalLinea);
            }else{
                baseIva0+=parseFloat(DATA.totalLinea);
            }
        })
        totalIva = (baseIva*this.state.paramIva)/100
        let retencion = this.state.total_retencion?parseFloat(this.state.total_retencion):0
        totalNeto = totalBruto + totalIva - retencion;

        this.setState({subtotalSinIva: subtotalSinIva.toFixed(2), descuentoTotal: descuentoTotal.toFixed(2), 
            totalBruto: totalBruto.toFixed(2), baseIva: baseIva.toFixed(2), baseIva0: baseIva0.toFixed(2),
            totalIva: totalIva.toFixed(2), totalNeto: totalNeto.toFixed(2)})

        console.log('VALORES: ', subtotalSinIva , descuentoTotal, totalBruto, baseIva,
        baseIva0, totalIva, totalNeto)

       
        this.apiGridDetalleArt.refreshCells();
    }

    setProveedor(value){
        if(Array.isArray(value)){
            value=null
        }
        
        if(value===null){
            
            this.setState({proveedor: null, proveedor_sel: null});
            
        }else{
            let codProv = value.value;
            //CALL API
            let config_request = {
                method: 'GET',
                url: '/proveedores/'+codProv.toString()
            };

            global_axios(config_request)
            .then((response)=>{
                let proveedorData = {};
                let proveedorResponse = {}
                proveedorResponse = response.data
                
                if(proveedorResponse.DebitoBancario!==null && this.state.operacion==='G'){
                    this.setState({debitoBancario: proveedorResponse.DebitoBancario})
                }else if(this.state.operacion==='G'){
                    this.setState({debitoBancario: 'N'})
                }

                if(proveedorResponse.ret_iva){
                    proveedorData.ret_iva = { codigo: proveedorResponse.ret_iva, porc: proveedorResponse.Retencion2 };
                }

                if(proveedorResponse.ret_fte){
                    proveedorData.ret_fte = { codigo: proveedorResponse.ret_fte, porc: proveedorResponse.Retencion1 }
                }  
                
                if(proveedorResponse.tipo_persona){
                    proveedorData.tipo_persona = proveedorResponse.tipo_persona;
                }

                if(proveedorResponse.fecha_autorizacion){
                    proveedorData.fecha_autorizacion = proveedorResponse.fecha_autorizacion;
                }

                if(proveedorResponse.num_autorizacion){
                    proveedorData.num_autorizacion = proveedorResponse.num_autorizacion;
                }

                Promise.all([
                    cargarCatalogosGenerico('/catalogos?tipo=tabla&opcion=Retencion&cadena_busq='+response.data.rubro_imp),
                    this.cargarCuentasContables(proveedorResponse.cta_contable!==null?(proveedorResponse.cta_contable.trim()!== ""?proveedorResponse.cta_contable.trim():null):null, this.state.planVigente),
                ])
                .then(([ respuesta, c_cta_contable ])=>{

                    if(proveedorResponse.rubro_imp){
                        proveedorData.rubro_imp = respuesta[0];
                    } 
                    
                    if(proveedorResponse){                         
                        //OBTENER CUENTA Contable
                        var cta_contable = {}
                        if(c_cta_contable !== null){
                            cta_contable.value = c_cta_contable.Cuenta;
                            cta_contable.label = c_cta_contable.Nombre;
                            proveedorData.cta_contable = cta_contable
                            this.setState({errorCuentas: 0, ctaContable: cta_contable})
                        }else{
                            proveedorData.cta_contable = null;
                            alert("El proveedor no tiene registrada una cuenta contable, no se puede continuar...")
                            this.setState({errorCuentas: 1, ctaContable: null})
                        }
                    }else{
                        alert("Error: revise los datos del proveedor seleccionado antes de continuar")
                    }
                    this.setState({proveedor: proveedorData, proveedor_sel: value});
                })
                .catch((error)=>{                
                    alert(error.response?error.response.data.msg:error.message);      
                });
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    cargarCuentasContables(cuenta, plan){
        return new Promise((resolve, reject) => {
            global_axios.get('/cuentas/'+cuenta+'/'+plan)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    //Handler Factura
    changeNumSerie(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        if(value.length <=6){
            if(isNaN(value)===false){
                this.setState({[name]: value});
            }
        } 
    }

    changeNumFactura(event){    
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        if(value.length <=9){
            if(isNaN(value)===false){
                this.setState({            
                    [name]: value
                    });
            }
        }   
    }

    validNumSerie(){
        var numSerie = this.state.num_doc_serie.toString();
        var establecimieto = this.state.num_doc_serie.toString().substr(0,3);
        var serie = this.state.num_doc_serie.toString().substr(3,3);
        var e = establecimieto
        var s = serie
        if(numSerie.length === 6){
            if(parseInt(e,10) === 0 || parseInt(s,10) === 0){
                this.setState({num_doc_serie: ''});
                document.getElementsByName('num_doc')[0].focus();
                alert("Revisar serie del número de documento");
            }
        }else{
            this.setState({num_doc_serie: ''});
            document.getElementsByName('num_doc')[0].focus();
            alert("Revisar serie del número de documento");
        }
    }

    validadFacturaProveedor(event){
        var errors = "";
        var proceder = true;
        const target = event.target;       
        const value = target.value; 

        if(!this.state.proveedor_sel || this.state.tipoDocumento===null){
            proceder = false;
            errors=errors+"- Revise los campos proveedor o el tipo de documento seleccionado\n"
        }

        if(this.state.num_doc_serie === "" || this.state.num_doc === ""){
            proceder = false;
            errors=errors+"- Ingrese correctamente la serie y la factura"
        }

        if(proceder === true){
            var data = {};
            data.Proveedor = this.state.proveedor_sel.value.toString();
            data.Tipo = this.state.tipoDocumento_sel.value;
            data.Establecimiento = this.state.num_doc_serie.toString().substr(0,3)
            data.PuntoVenta = this.state.num_doc_serie.toString().substr(3,6)
            data.Factura = value
            
            //Validacion factura y serie ingresada 
            let config_request = {
                method: 'GET',
                url: '/compras?proveedor='+data.Proveedor+'&tipo='+data.Tipo+'&establecimiento='+data.Establecimiento+'&puntoventa='+data.PuntoVenta+'&factura='+data.Factura
            };
            
            global_axios(config_request)
            .then((response)=>{
                var array_resultados = [];
                array_resultados = response.data
                if(array_resultados.length>0){
                    alert("La serie y el número de factura ingresado ya existe para este proveedor!");
                    this.setState({num_doc_serie: "", num_doc: ""})
                }
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }else{
            //Cambia el foco al siguiente control
            document.getElementsByName('totalDocumento')[0].focus();
            alert(errors)
        }
    }

    //Op Arrays Inmutables
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    clear(param){
        if(param === 'A'){
            this.setState({movCompra: ''})
        }
        let tipoDocDefault = this.state.tipoDocDefault;
        let fechaProceso = getFechaProcesoPorModulo('06');
        
        this.clearAddImp();
        this.clearAddItems();

        this.setState({operacion: 'G', diasPago: 1, errorCuentas: 0,
        proveedor_sel: null,
        proveedor: null,
        ctaContable: null,
        debitoBancario: 'N',

        bodega_sel: '01',
        modStock: 'S',

        num_doc: '',
        num_doc_serie: '',
        totalDocumento: 0,

        //Indicadores Valores
        subtotalSinIva: 0,
        descuentoTotal: 0,
        totalBruto: 0,
        baseIva: 0,
        baseIva0: 0,
        totalIva: 0,
        totalNeto: 0,

        tipo_compra_sel: null,
        tipoDocumento_sel: tipoDocDefault,

        opt_impuestos_sel: null,
        porcentaje_imp: '',
        base_imponible: '',
        valor_impuesto: '',
        rubroVisible: false, //Control para ocultar la fila rubro
        total_retencion: 0,

        //Input
        concepto: '',

        //revisar Retencion
        retencionRevisada: false,
        
        //Grids
        gridRetenciones: [],
        gridDetalleArt: [],
        gridOrdenesCompra: [],

        //Totales Retenciones
        impRetIva: 0, 
        impRetRtf: 0

        },()=>{
            this.setState({fechaProceso: moment(fechaProceso,'DD/MM/YYYY'),
            fechaFactura: moment(fechaProceso,'DD/MM/YYYY'),
            fechaVencimiento: moment(fechaProceso,'DD/MM/YYYY').add(this.state.diasPago, 'days')})
        })
    }

    clearAddItems(){
        this.setState({articulo_sel: null, 
        ivaArticulo: 'N', cantArt: '', precioUnit: '', descuentoArt: '', descuentoPorcArt: '0'})
    }

    clearAddImp(){
        this.setState({opt_impuestos_sel: null, porcentaje_imp: '', base_imponible: '', valor_impuesto: '',
            rubroVisible: false})
    }

    //PROCEDURE MODALS
    addImpuesto(){
        var errors = "";
        var continuar = true;

        if(this.state.base_imponible === 0){
            continuar = false;
            errors = errors+"- No se puede añadir si no existe base superior a 0.\n";
        }

        if(!this.state.opt_impuestos_sel){
            continuar = false;
            errors = errors+"- Seleccione un impuesto de la lista\n";
        }else{

        }

        if(this.state.opt_impuestos_sel.tipo === "RTF"){
            if(parseInt(this.state.opt_impuestos_sel.porcentaje,10) !== 0 && this.state.rubro.value === this.state.parametroNo_OBJ_IVA){
                continuar = false;
                errors = errors+"- La retencion 0 solo se le debe asignar el rubro 332.\n";
            }
        }

        let totales = this.sumarRetenciones();
        let totalIva = totales.impRetIva +parseFloat(this.state.valor_impuesto);
        let maxIva = parseFloat(this.state.totalIva).toFixed(2)
        console.log('TOTAL RET: ',totalIva.toFixed(2), 'IVA: ', maxIva, 'TOTALES: ', totales)
        // Verifica si el total IVA se excede en la pantalla de retencion y el impuesto a Ingresar es IVA
        if(totalIva>maxIva && this.state.opt_impuestos_sel.tipo==='IVA'){
            continuar = false;
            errors = errors+"- El valor ingresado supera a la base del IVA.\n";
        }

        var respuesta = this.validarImpRepetidos(this.state.gridRetenciones, this.state.opt_impuestos_sel.tipo, this.state.opt_impuestos_sel.value );
        if(respuesta === true){
            errors += `- Registro tipo: ${this.state.opt_impuestos_sel.tipo} se encuentra ingresado.\n`
        }

        if(continuar === true){
            let item = {};

            item.tipo_descripcion = 'Bienes'
            item.Tipo = 'B'
            item.codigo = this.state.opt_impuestos_sel.value;
            item.descripcion = this.state.opt_impuestos_sel.label;
            item.porcentaje = this.state.porcentaje_imp;
            item.base_calculo = parseFloat(this.state.base_imponible,10)?parseFloat(this.state.totalIva,10):0
            item.valor = Math.round(this.state.valor_impuesto*100)/100;
            item.TipoImp = this.state.opt_impuestos_sel.tipo==='IVA'?'IVA':'RTF';

            if(this.state.opt_impuestos_sel.tipo==='RTF'){
                item.rubro = this.state.rubro.label;
                item.rubro_num = this.state.rubro.value;
            }

            //item.CuentaContable = this.selectorCuentaImpProveedor(fila_data); //fila_data.CuentaContable.trim();

            this.setState({ gridRetenciones: this.immutablePush(this.state.gridRetenciones, item) })
            this.clearAddImp();
        }else{
            alert(errors)
        }
    }

    validarImpRepetidos(array, tipo, valor){
        var result = false;
        array.forEach((DATA)=>{
            if(DATA.codigo === valor || DATA.TipoImp === tipo){
                result = true;
            }
        })
        return result;
    }

    sumarRetenciones(){
        let total = 0, iva = 0, rtf = 0
        this.state.gridRetenciones.forEach((DATA)=>{
            if(DATA.TipoImp==='IVA'){
                iva+=Math.round(parseFloat(DATA.valor)*100)/100;
            }else{
                rtf+=Math.round(parseFloat(DATA.valor)*100)/100; 
            }
            total+=Math.round(parseFloat(DATA.valor)*100)/100;
        })

        this.setState({total_retencion: total, impRetIva: iva, impRetRtf: rtf})

        return {total_retencion: total, impRetIva: iva, impRetRtf: rtf}
    }

    retencionesAutomaticas(){
        let iva = 0, rtf = 0;
        if(this.state.gridRetenciones.length === 0){
            console.log('entro a insertar')
            /* INSERT */            
            if(this.state.proveedor){
                /*  VALIDACION IMP RET IVA */
                let filaIva = {}, filaRtf = {}, controlIva = false, controlRft = false, totalRet = 0, array = [];
                if(this.state.proveedor.hasOwnProperty('ret_iva')){
                    let impIva = this.obtenerDataCatalogo(this.state.opt_impuestos , this.state.proveedor.ret_iva.codigo.toString(), "value");
                    console.log('IMPUESTO: ', impIva)
                    if(impIva){
                        /* EXISTE IVA IMP. */
                        controlIva = true
                        filaIva.tipo_descripcion = 'Bienes'
                        filaIva.Tipo = 'B'
                        filaIva.codigo = impIva.value;
                        filaIva.descripcion = impIva.label;
                        filaIva.porcentaje = impIva.porcentaje;
                        filaIva.base_calculo = parseFloat(this.state.totalIva,10)?parseFloat(this.state.totalIva,10):0
                        filaIva.valor = Math.round(filaIva.base_calculo * (filaIva.porcentaje/100)*100)/100;
                        totalRet+= filaIva.valor;
                        filaIva.TipoImp = 'IVA';
                        filaIva.CuentaRetencion1 = this.selectorCuentaImpProveedor(impIva)
                        iva+=filaIva.valor;
                    }
                }
                
                /*  VALIDACION IMP RET FUENTE */
                if(this.state.proveedor.hasOwnProperty('ret_fte')){
                    let impRtf = this.obtenerDataCatalogo(this.state.opt_impuestos , this.state.proveedor.ret_fte.codigo.toString(), "value");
                    console.log('IMPUESTO RTF: ', impRtf)
                    if(impRtf){
                        /* EXISTE RTF IMP. */
                        controlRft = true
                        filaRtf.tipo_descripcion = 'Bienes'
                        filaRtf.Tipo = 'B'
                        filaRtf.codigo = impRtf.value;
                        filaRtf.descripcion = impRtf.label;
                        filaRtf.porcentaje = impRtf.porcentaje;
                        filaRtf.base_calculo = parseFloat(this.state.baseIva,10)?parseFloat(this.state.baseIva,10):0
                        filaRtf.valor = Math.round(filaRtf.base_calculo * (impRtf.porcentaje/100)*100)/100;
                        
                        if(this.state.proveedor.rubro_imp){
                            filaRtf.rubro_num = this.state.proveedor.rubro_imp.value;
                            filaRtf.rubro = this.state.proveedor.rubro_imp.label;
                        }
                        totalRet+= filaRtf.valor
                        filaRtf.TipoImp = 'RTF'
                        filaRtf.CuentaRetencion1 = this.selectorCuentaImpProveedor(impRtf);
                        rtf+=Math.round(filaRtf.valor*100)/100;                        
                    }
                }
                console.log('CONTROL IVA: ', controlIva)
                if(controlIva){
                    array.push(filaIva);
                }

                console.log('CONTROL FTE: ', controlRft)
                if(controlRft){
                    array.push(filaRtf);
                }

                console.log('ARRAY: ', array)
                if(array.length > 0){
                    this.setState({gridRetenciones: array, total_retencion: totalRet, impRetIva: iva, impRetRtf: rtf})
                }
            }            
        }else{
            /* UPDATE */
            console.log('entro a actualizar')
            console.log('BASE IVA', this.state.baseIva)
            console.log('BASE IVA', this.state.totalIva)
            let totalRet = 0
            let array = this.state.gridRetenciones;
            array.forEach((RET)=>{
                if(RET.TipoImp==='IVA'){
                    RET.base_calculo = parseFloat(this.state.totalIva,10)?parseFloat(this.state.totalIva,10):0
                    RET.valor = Math.round(RET.base_calculo * (RET.porcentaje/100)*100)/100;
                    iva += RET.valor;
                }else{
                    RET.base_calculo = parseFloat(this.state.baseIva,10)?parseFloat(this.state.baseIva,10):0
                    RET.valor = Math.round(RET.base_calculo * (RET.porcentaje/100)*100)/100;
                    rtf += RET.valor;
                }
                totalRet+= RET.valor
            })
            var newArr = [ ...array ]
            this.setState({total_retencion: Math.round(totalRet*100)/100, gridRetenciones: [], impRetIva: iva, impRetRtf: rtf},()=>{
                this.setState({gridRetenciones: newArr})
            })
        }
    }

    //Devuelve toda la fila del catalogo
    obtenerDataCatalogo(array , valor , name){
        var respuesta;
        array.forEach((DATA)=>{
            if(DATA[name] === valor){
                respuesta = DATA;
            }
        })
        return respuesta;
    }

    //Busca el Impuesto para cada retencion
    selectorCuentaImpProveedor(filaImp){
        var tipoPersona = null;
        var result = null;
        tipoPersona = this.state.proveedor.tipo_persona!==null?this.state.proveedor.tipo_persona:null;
        
        if(tipoPersona!==null){
            if(tipoPersona==='N'){
                if(filaImp.CContableProvPN!==null && filaImp.CContableProvPN!==''){
                    result = filaImp.CContableProvPN
                }
            }else if(tipoPersona==='J'){
                if(filaImp.CContableProvPJ!==null && filaImp.CContableProvPJ!==''){
                    result = filaImp.CContableProvPJ
                }
            }
        }
        if(result===null && filaImp.Codigo!=="19"){
            this.setState({errorCuentas: 1});
        }
        // else{
        //     this.setState({errorCuentas: 0});
        // }
        
        return result
    }

    setPorcentajeImp(value){
        console.log('SELECTED: ', value , 'BASE: ', this.state.baseIva, 'IVA: ',  this.state.totalIva)
        if(value){
            let base = 0, rubroVisible = false;
            if(value.tipo==='IVA'){
                base = parseFloat(this.state.totalIva,10);
            }else{
                base = parseFloat(this.state.baseIva,10);
                rubroVisible = true
            }
            
            let valor = base * (value.porcentaje/100);
            this.setState({opt_impuestos_sel: value, porcentaje_imp: value.porcentaje, 
            base_imponible: base, valor_impuesto: Math.round(valor*100)/100, rubroVisible: rubroVisible});
        }else{
            this.setState({opt_impuestos_sel: null})
        }
    }

    methodFromParent(id, datos_fila){
        if(this.state.operacion==='G'){
            var mensaje;
            mensaje = window.confirm("¿Desea eliminar el registro?"); 
            
            if (mensaje){
                if(datos_fila.hasOwnProperty('base_calculo') && this.state.operacion === 'G'){
                    this.eliminarRetencion(datos_fila ,id) 
                }
            }
        }else{
            alert('- Operación no permitida')
        }
    }

    eliminarRetencion(datos_fila ,id){
        this.setState({ gridRetenciones: this.immutableDelete(this.state.gridRetenciones, id)},()=>{
            this.sumarRetenciones();
            this.sumaGridDetalleArticulo();
        })
    }

    //ModalOrdenesPago
    toogleOrdenesCompra(){
        this.setState({isOpenOrdenCompra: !this.state.isOpenOrdenCompra})
    }

    closeOrdenCompra(){
        this.setState({isOpenOrdenCompra: false})
    }

    //creacionDCompra
    creacionDCompra(){
        let DCompra = [];
        let detalle = this.state.gridDetalleArt;

        detalle.forEach((DET, i)=>{
            let item = {};

            item.Localidad = '01';
            item.Compra = '';
            item.Secuencia = i + 1;
            item.Articulo = DET.codigoArticulo;
            item.Bodega = this.state.bodega_sel;
            item.CantidadEmpaque = 0;
            item.Cantidad = DET.cantidad;
            item.DevuelveEmpaque = 0;
            item.Devuelve = 0;
            item.Precio = parseFloat(DET.precioUnitario,10);
            item.Bonifica = 0;
            item.Empaque = 0;
            item.Utilidad = 0;
            item.Iva = DET.indicadorIva==='S'?1:0;
            item.Variedad = 0;
            item.Descuento = DET.valorDescuento?parseFloat(DET.valorDescuento):0;
            item.Factura = this.state.num_doc.toString().trim();
            item.ICE = 0;

            DCompra.push(item);
        })

        return DCompra; 
    }

    genRetencionRenta(mensajeRET0){
        var grid_retencion = [];
    
            this.state.gridRetenciones.forEach((DATA)=>{
                var item = {};
                item.Retencion = '';
                item.Factura = this.state.num_doc.toString().trim();
                item.Compra = '';
                item.Valor = DATA.base_calculo;
                item.ValorRetenido = DATA.valor;
                item.Porcentaje = DATA.porcentaje;
    
                //MARCADOR DE RETENCION 0%
                if(item.Porcentaje === 0){
                    mensajeRET0 = ' - Existen retenciones por 0%, no se enviara el comprobante electronico'
                }
    
                item.Proveedor = this.state.proveedor_sel.value;
                item.CuentaRetencion1 = DATA.CuentaRetencion1;
                item.Fecha = formatearFechaMoment_a_String(this.state.fechaProceso);
                item.Codigo = DATA.codigo;

                if(DATA.TipoImp === "IVA"){
                    item.Observacion = "IVA";
                    item.Rubro = "";
                }else{
                    item.Observacion = "FUENTE";
                    item.Rubro = DATA.rubro_num;
                }
                item.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
                item.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
                item.Secuencia = '';
                item.RetencionSRI = '';
                item.Establecimiento = '';
                item.PuntoVenta = '';
                item.Status = 'P';
                item.Tipo = DATA.Tipo;
    
                grid_retencion.push(item);
            })

        return grid_retencion;
    }

    //ACTIONS
    guardarCompraLocal(){
        var errors = "";
        var proceder = true;
        let mensajeRET0 = '';

        let fechaProcesoModulo = getFechaProcesoPorModulo('06');
        //VALIDACION DE FECHA DE CIERRE CONTABLE        
        //var fechaCierreCont = moment(getItemDatosSesion('fechaUltCierreCont'), 'DD/MM/YYYY');
        
        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProcesoModulo, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        /* VALIDACION DE FECHA PROCESO Y FECHA FACTURA */ 
        if(this.state.fechaProceso && this.state.fechaFactura){
            var fechaProceso = this.state.fechaProceso;
            var fechaFactura = this.state.fechaFactura;
            //VERIFICACION FECHA TRANSACCION CON FECHA FACTURA
            if(fechaFactura.isAfter(fechaProceso)===true){
                proceder = false;
                errors += '- La fecha factura no puede ser mayor a la fecha de transacción\n'
            }
        }else{
            proceder = false;
            errors += '- Ingrese una fecha para fecha del proceso y otra para la fecha de la factura\n'
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg+'\n'
        }

        console.log('COMPARACION: ', Math.round(parseFloat(this.state.totalDocumento,10)*100)/100 !== Math.round((parseFloat(this.state.totalBruto,10) + parseFloat(this.state.totalIva,10))*100)/100, 'totalDoc', parseFloat(this.state.totalDocumento,10), 'importe: ', parseFloat(this.state.totalBruto,10) + parseFloat(this.state.totalIva,10))

        if(Math.round(parseFloat(this.state.totalDocumento,10)*100)/100 !== Math.round((parseFloat(this.state.totalBruto,10) + parseFloat(this.state.totalIva,10))*100)/100){
            proceder = false;
            errors = errors + '- El total del documento es incorrecto '+ Math.round((parseFloat(this.state.totalBruto,10) + parseFloat(this.state.totalIva,10))*100)/100+'\n' ;
        }

        if(this.state.tipoDocumento_sel === null){
            proceder = false;
            errors = errors + '- Seleccione un tipo de documento.\n'
        }else if(this.state.tipoDocumento_sel.NoProcesarRet === null  && this.state.gridRetenciones.length === 0){
            proceder = false;
            errors = errors + '- Ingrese retenciones para el tipo seleccionado.\n'
        }

        if(this.state.tipoDocumento_sel){
            if(this.state.retencionRevisada === false && this.state.tipoDocumento_sel.NoProcesarRet === null){
                proceder = false;
                errors = errors + '- Revisar retenciones\n'
            }
        }

        if(proceder === true){
            let data = {};
            let descuentoTotal = parseFloat(this.state.descuentoTotal, 10);
            let totalBruto = parseFloat(this.state.totalBruto, 10);
            let Iva = parseFloat(this.state.totalIva,10);

            //COMPRA
            data.Proveedor = this.state.proveedor_sel.value;
            data.Tipo = this.state.tipo_compra_sel.value;
            data.Factura = this.state.num_doc.toString().trim();
            data.fechaProceso = formatearFechaMoment_a_String(this.state.fechaProceso);
            data.fechaVencimiento = formatearFechaMoment_a_String(this.state.fechaVencimiento);
            data.fechaFactura = formatearFechaMoment_a_String(this.state.fechaFactura);
            data.concepto = this.state.concepto.trim().toUpperCase();
            data.FormaPago = 'CR';
            
            data.paramIVA = this.state.paramIva;
            data.IVA = parseFloat(this.state.totalIva, 10);
            data.Importe = Math.round(((totalBruto + Iva))*100)/100;
            data.TotalSinIVA = parseFloat(this.state.baseIva0, 10);
            data.TotalConIVA = parseFloat(this.state.baseIva, 10);
            data.saldo = (this.state.doc_precancelado===true?0:Math.round(parseFloat(this.state.totalNeto,10) * 100) / 100);
            data.Descuento = Math.round(parseFloat(descuentoTotal,10)*100)/100;
            
            data.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
            data.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;

            data.Usuario = this.props.usuario;
            data.Status = 'P';

            //TOTALES
            data.retencion = Math.round(parseFloat(this.state.total_retencion) * 100) / 100;

            data.Establecimiento = this.state.num_doc_serie.toString().substr(0,3);
            data.PuntoVenta = this.state.num_doc_serie.toString().substr(3,6)
            data.plancontable = this.state.planVigente;
            data.DiasPg = parseInt(this.state.diasPago,10);

            data.debitoBancario = this.state.debitoBancario;
            data.PtoFacturacion = this.props.puntoFacturacionSel
            data.Periodo = getItemDatosSesion('periodo');

            //DCOMPRA
            data.dCompraArray = this.creacionDCompra();

            //DETALLE RETENCIONES
            data.RetencionRenta = this.genRetencionRenta();
            
            //TIPO DE DOCUMENTO ENVIADO;
            data.Tipo = this.state.tipoDocumento_sel.value;

            //PARAMETRO PARA PROCESAR RETENCION (PROCESA RET === NULL)
            data.NoProcesarRet = this.state.tipoDocumento_sel.NoProcesarRet;

            data.AfectacionBodega = this.state.modStock==='S'?1:0;

            data.CreditoTributario = this.state.tipo_compra_sel;

            data.Caducidad = this.state.proveedor.fecha_autorizacion?(this.state.proveedor.fecha_autorizacion):'31/12/2019';
            data.Autorizacion = this.state.proveedor.num_autorizacion;

            console.log('ENVIO DATA: ', data)

            let config_request = {
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: this.state.operacion==='G'?'/compraslocales':'/compraslocales/'+this.state.movCompra,
                data
            }
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=> {  
                if(response){
                    console.log('RESPUESTA INS UPD: ', response)
                    this.props.cambiar_VisualizacionLoading(false);
                    //Advertencia para RETENCION 0%
                    if(mensajeRET0){
                        alert(mensajeRET0)
                    }
                    alert(response.data.msg);
                    this.clear('B');
                    
                    this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.diario, movCompra: response.data.transaction}, ()=>{
                        this.setState({operacion: 'G'})
                    })
                }else{
                    alert('- Error al cargar data de la compra')
                }                  
            })
            .catch((error)=>{   
                this.props.cambiar_VisualizacionLoading(false);             
                alert(error.response?error.response.data.msg:error.message);  
            });
        }else{
            alert(errors)
        }
    }

    impCompra(){
        visualizarReporteEnPdf('&rpt=28&param1='+this.state.movCompra)
    }

    validarTipoDoc(){
        let desactivado = true;
        if(this.state.tipoDocumento_sel){
            if(this.state.tipoDocumento_sel.NoProcesarRet === null){
                desactivado = false;
            }
        }
        return desactivado;
    }

    render(){
        return(
            <ContenedorForm porc_ancho={80}>
                <HeaderForm>
                    <TituloForm>Compras por Artículos</TituloForm>
                    <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                    <LabelCabecera>N°. diario.: {this.state.num_diario}</LabelCabecera>
                    <LabelCabecera>RET. IVA: {formatearNumeroDecimal(this.state.impRetIva)}</LabelCabecera>   
                    <LabelCabecera>RET. FTE.: {formatearNumeroDecimal(this.state.impRetRtf)}</LabelCabecera>        
                </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit alto='50'>
                        <Row>
                            <ContainerCol className='col-md-1'>
                                <LabelForm>Compra: </LabelForm>
                            </ContainerCol>  
                            <ContainerCol className='col-md-2'>
                                <InputSearch tipoInput='text' nombre='movCompra' valor={this.state.movCompra} func_CambiarValor={this.handleInputChange}
                                    func_BuscarValor={this.getCompra} func_OnFocus={()=>{this.clear('B')}}/>
                            </ContainerCol>
                            <ContainerCol className='col-md-1 col-md-push-6'> 
                                <LabelForm>Fecha:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-md-2 col-md-push-6'> 
                                <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={!(this.props.permiteCambioFProceso==='S')} func_onChange={(fechaEscogida)=>{this.changeFechaProceso(fechaEscogida)}}/>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha documento:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaFactura} func_onChange={(fechaEscogida)=>{this.changeFecha(fechaEscogida)}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>Días pg.:</LabelForm>
                            <InputText name='diasPago' value={this.state.diasPago} type="text" maxLength={3} className='form-control input-sm' onChange={this.handleInputChange} onBlur={this.changeDiasPago}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Vencimiento:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaVencimiento} disabled={true} />
                        </ContainerCol>
                        <ContainerCol className='col-md-3'>
                            <LabelForm>Proveedor:</LabelForm>
                            <ReactSelectAsync value={this.state.proveedor_sel} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.setProveedor(value)}}/>
                        </ContainerCol>                        
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Tipo documento:</LabelForm>
                            <ReactSelect options={ this.state.tipoDocumento } value={this.state.tipoDocumento_sel} disabled={this.state.operacion === 'G'?false:true} func_onChange={(value)=>{value!==null?this.setState({tipoDocumento_sel: value}):this.setState({tipoDocumento_sel: null})}} />
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>N° documento:</LabelForm>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"></span>
                                </div>
                                <InputText2 className='input-sm' type="text" name='num_doc_serie' disabled={this.state.proveedor_sel===null || this.state.operacion === 'M'?true:false} value={this.state.num_doc_serie} onChange={this.changeNumSerie} onBlur={this.validNumSerie}/>
                                <InputText2 className='input-sm' type="text" name='num_doc' disabled={this.state.proveedor_sel===null || this.state.operacion === 'M'?true:false} value={this.state.num_doc}  onChange={this.changeNumFactura} onBlur={this.validadFacturaProveedor}/>
                            </div>
                        </ContainerCol>                        
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>Debito Bancario:</LabelForm><br/>
                            <LabelForm><input type='checkbox' name='debitoBancario' checked={this.state.debitoBancario==='S'?true:false} onChange={this.handleInputChange}/></LabelForm> 
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Orden de Compra:</LabelForm>
                            {/* <ReactSelect options={ this.state.opt_orden_compra } value={this.state.orden_compra_sel} disabled={this.state.opt_orden_pago.length === 0?true:false} func_onChange={(value)=>{this.setState({orden_compra_sel: value!==null?value.value:null})}}/> */}
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <button type='button' className='btn btn-default btn-sm' onClick={this.toogleOrdenesCompra}><i className='fa fa-plus'></i>  Añadir</button>
                                </ContainerCol>
                            </Row>
                            
                        </ContainerCol>
                        <ContainerCol className='col-md-3'>
                            <LabelForm>Bodega Ingreso:</LabelForm>
                            <ReactSelect options={ this.state.opt_bodegas } value={this.state.bodega_sel}  func_onChange={(value)=>{this.setState({bodega_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>                        
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Agregar art. a bodega:</LabelForm>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelForm className='radio-inline'>
                                        <input type="radio" name="modStock" value="S" checked={this.state.modStock==="S"} onChange={this.handleInputChange} />Si
                                    </LabelForm>
                                    <LabelForm className='radio-inline'>
                                        <input type="radio" name="modStock" value="N" checked={this.state.modStock==="N"} onChange={this.handleInputChange} />No
                                    </LabelForm>
                                </ContainerCol>
                            </Row>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Total documento:</LabelForm>
                            <InputText name='totalDocumento' value={this.state.totalDocumento}  className='form-control input-sm' onChange={this.evalNumberInput} onBlur={this.corregirValor} maxLength={7}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-5'>
                            <LabelForm>Cretido Tributario:</LabelForm>
                            <ReactSelect options={ this.state.tipo_compra_opt } value={this.state.tipo_compra_sel} func_onChange={(value)=>{this.setState({tipo_compra_sel: value?value.value:null})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-5'>
                            <LabelForm>Concepto:</LabelForm>
                            <InputText mayusculas='true' name='concepto' value={this.state.concepto}  className='form-control input-sm' onChange={this.handleInputChange} maxLength={50}/>
                        </ContainerCol>
                    </Row>                    
                    <Row>
                        <ContainerCol className='col-md-4'>
                            <LabelForm>Artículo:</LabelForm>                
                            <SelectArticulo func_ref={ref=>{this.asyncRef = ref}} tipoArticulos='P' value={this.state.articulo_sel} 
                            func_onChange={(value)=>{if(Array.isArray(value)){value=null;} this.setState({articulo_sel: value})}}/>
                        </ContainerCol>
                        <ContainerCol margen_arriba={2} className='col-md-1'>
                            <LabelForm>Ind. IVA:</LabelForm>
                            <Row>
                                <ContainerCol className='col-md-1'>
                                    <LabelForm><input type='checkbox' name='ivaArticulo' checked={this.state.ivaArticulo==='S'?true:false} onChange={this.handleInputChange}/></LabelForm> 
                                </ContainerCol>
                            </Row>                            
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>Cant.:</LabelForm>
                            <InputText name='cantArt' value={this.state.cantArt}  className='form-control input-sm' onChange={this.evalNumberInput} onBlur={this.fixtoNumberIn} maxLength={3}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>P. Unit.:</LabelForm>
                            <InputText ancho={110} name='precioUnit' value={this.state.precioUnit}  className='form-control input-sm' onChange={this.evalNumberInput} maxLength={9}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>% Dscto:</LabelForm>
                            <InputText name='descuentoPorcArt' value={this.state.descuentoPorcArt}  className='form-control input-sm' onChange={this.evalNumberInput} maxLength={7}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>V. Dscto.:</LabelForm>
                            <InputText name='descuentoArt' value={this.state.descuentoArt}  className='form-control input-sm' onChange={this.evalNumberInput} maxLength={7}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <ContenedorBoton>
                                        <Tooltip placement='right' overlay='Añadir/Quitar un artículo'>
                                            <div className='btn-group pull-left'>
                                                <button type='button' className='btn btn-success btn-sm' onClick={this.handleAddArticulo}><i className='fa fa-plus'></i></button>
                                                <button type='button' className='btn btn-danger btn-sm' onClick={this.handleDeleteArticulo}><i className='fa fa-window-close'></i></button>
                                            </div>
                                        </Tooltip>
                                    </ContenedorBoton>
                                </ContainerCol>
                            </Row>                            
                        </ContainerCol> 
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-12'>
                            <LabelForm>Detalle:</LabelForm>
                            <AgGridRender  altura='190px' data={this.state.gridDetalleArt} columnas={this.state.columnDefsDetalleArt} gridOptions={this.gridOptionsDetalleArt} onGridReady={this.onGridReadyDetalleArt}/>   
                        </ContainerCol>                            
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-1'>
                            <LabelTotales>Subtotal:</LabelTotales>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelValorTotales>{formatearNumeroDecimal(this.state.subtotalSinIva)}</LabelValorTotales>
                                </ContainerCol>                                
                            </Row>                            
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelTotales>Descuento.:</LabelTotales>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelValorTotales>{formatearNumeroDecimal(this.state.descuentoTotal)}</LabelValorTotales>
                                </ContainerCol>                                
                            </Row>                            
                        </ContainerCol>  
                        <ContainerCol className='col-md-1'>
                            <LabelTotales>T. Bruto:</LabelTotales>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelValorTotales>{formatearNumeroDecimal(this.state.totalBruto)}</LabelValorTotales>
                                </ContainerCol>                                
                            </Row>                            
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelTotales>Base(IVA):</LabelTotales>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelValorTotales>{formatearNumeroDecimal(this.state.baseIva)}</LabelValorTotales>
                                </ContainerCol>                                
                            </Row>                            
                        </ContainerCol>  
                        <ContainerCol className='col-md-1'>
                            <LabelTotales>Base(IVA0):</LabelTotales>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelValorTotales>{formatearNumeroDecimal(this.state.baseIva0)}</LabelValorTotales>
                                </ContainerCol>                                
                            </Row>                            
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelTotales>T. IVA:</LabelTotales>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelValorTotales>{formatearNumeroDecimal(this.state.totalIva)}</LabelValorTotales>
                                </ContainerCol>                                
                            </Row>                            
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelTotales>Neto:</LabelTotales>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelValorTotales>{formatearNumeroDecimal(this.state.totalNeto)}</LabelValorTotales>
                                </ContainerCol>                                
                            </Row>                            
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba={10}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.errorCuentas===1?true:false} onClick={this.guardarCompraLocal}><i className="fa fa-floppy-o fa-lg" aria-hidden="true"/> Guardar</button>  
                                <button type="button" className='btn btn-danger btn-sm' disabled={this.state.operacion==='M'?false:true} onClick={this.anularCompra}><i className="fa fa-ban fa-lg"></i> Anular</button>
                                <button type="button" className='btn btn-sm' disabled={this.validarTipoDoc()} onClick={this.toggleModalRetencion}><i className="fa fa-book fa-lg"></i> Retenciones</button>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.movCompra===''?true:false} onClick={this.impCompra}><i className="fa fa-print fa-lg" aria-hidden="true"/> Comp.</button>
                                <button type="button" className='btn btn-sm' onClick={()=>{this.clear('A')}}><i className="fa fa-trash-o fa-lg"></i></button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>

                {/*MODAL RETENCION*/}
                <ModalResponsive open={this.state.isOpenRetencion} onClose={this.closeRetencion}>
                    <HeaderForm>
                        <TituloForm>Retenciones</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModal>
                            <Row>
                                <ContainerCol className='col-md-1'>
                                    <LabelForm>Serie: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-4'>
                                    <PuntoFacturacion disabled={true}/>
                                </ContainerCol>
                            </Row> 
                            <Row>
                                <ContainerCol className='col-md-4'>
                                    <LabelForm>Impuesto:</LabelForm>
                                    <ReactSelect options={ this.state.opt_impuestos } disabled={this.state.operacion==='M'?true:false} value={this.state.opt_impuestos_sel} func_onChange={(value)=>{this.setPorcentajeImp(value)}}/>
                                </ContainerCol>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Porcentaje:</LabelForm>
                                    <InputText name='porcentaje_imp' value={this.state.porcentaje_imp} disabled={true} type="number" className='form-control input-sm' placeholder='%' onChange={this.handleInputChange}/>
                                </ContainerCol>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Base imponible:</LabelForm>
                                    <InputText name='base_imponible' value={this.state.base_imponible} disabled={this.state.operacion==='M'?true:false} type="number" className='form-control input-sm' placeholder='0.00' onChange={this.handleInputChange} onBlur={this.updateBaseImp}/>
                                </ContainerCol>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Valor impuesto:</LabelForm>
                                    <InputText name='valor_impuesto' value={this.state.valor_impuesto} disabled={true} type="number" className='form-control input-sm' placeholder='0.00' onChange={this.handleInputChange}/>
                                </ContainerCol>
                                <ContainerCol margen_arriba={-4} className='col-md-1'>
                                    <ContenedorBotonAdd>
                                        <button type="button" className='btn btn-success btn-sm' disabled={this.state.operacion==='M'?true:false} onClick={this.addImpuesto.bind(this)}><i className="fa fa-plus"></i></button>
                                    </ContenedorBotonAdd>
                                </ContainerCol>
                            </Row>
                            <Row margen_arriba={3} isInvisible={this.state.rubroVisible === true?false:true}>
                                <ContainerCol className='col-md-1'>
                                    <LabelForm>Rubro:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-11'>
                                    <ReactSelectAsync value={this.state.rubro} func_loadOptions={this.getOptions_RubroImp} func_onChange={(value)=>{this.setState({rubro: value})}}/>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <AgGridRender altura='140px' data={this.state.gridRetenciones} columnas={this.state.columnDefsRetenciones} gridOptions={this.gridOptionsRetenciones} onGridReady={this.onGridReadyRET}/>                                                           
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Total doc.:</LabelForm>
                                    <InputText name='subtotalSinIva' value={formatearNumeroDecimal(this.state.subtotalSinIva)} disabled={true} className='form-control input-sm' placeholder='0.00'/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Valor neto doc.:</LabelForm>
                                    <InputText name='totalNeto' value={formatearNumeroDecimal(this.state.totalNeto)} disabled={true} className='form-control input-sm' placeholder='0.00'/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>B. graba IVA:</LabelForm>
                                    <InputText name='baseIva' value={formatearNumeroDecimal(this.state.baseIva)} disabled={true} className='form-control input-sm' placeholder='0.00'/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>B. ret. renta:</LabelForm>
                                    <InputText name='baseIva' value={formatearNumeroDecimal(this.state.baseIva)} disabled={true} className='form-control input-sm' placeholder='0.00'/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>IVA:</LabelForm>
                                    <InputText name='totalIva' value={formatearNumeroDecimal(this.state.totalIva)} disabled={true} className='form-control input-sm' placeholder='0.00'/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Total retención:</LabelForm>
                                    <InputText name='total_retencion' value={formatearNumeroDecimal(this.state.total_retencion)} disabled={true} className='form-control input-sm' placeholder='0.00'/>
                                </ContainerCol>
                            </Row>                                       
                        </ContenedorModal>
                    </CuerpoForm>
                </ModalResponsive>
            
                {/*MODAL OrdenPago*/}
                <ModalResponsive open={this.state.isOpenOrdenCompra} onClose={this.closeOrdenCompra}>
                    <HeaderForm>
                        <TituloForm>Ordenes de Pago</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModalOrden>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelForm>{this.state.proveedor_sel?`Proveedor: ${this.state.proveedor_sel.label}`:''}</LabelForm>
                                </ContainerCol> 
                            </Row>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelForm>Detalle:</LabelForm>
                                    <AgGridRender altura='170px' data={this.state.gridOrdenesCompra} columnas={this.state.columnDefsOrdenCompra} gridOptions={this.gridOptionsOrdenesCompra} onGridReady={this.onGridOrdenCompra}/>   
                                </ContainerCol>                            
                            </Row>
                        </ContenedorModalOrden>
                    </CuerpoForm>
                </ModalResponsive>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {usuario: state.sesion.valoresSesionForm.Usuario,
            puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias
    }
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormComp11);